<template>
   <div>
       <headerTab :tabList="tabList"></headerTab>
       <div class="message">
           <div class="message_item" @click="goRouter('/systemMessage')">
               <el-badge :value="message.system.num" class="item">
                    <img src="../../assets/msg/msg_logo1.png" alt="">
               </el-badge>
               <div class="message_item_content">
                   <div class="message_item_content_title">系统通知</div>
                   <div class="message_item_content_time">{{message.system.time}}</div>
               </div>
           </div>
           <div class="message_item" @click="goRouter('/payMessage')">
               <el-badge :value="message.pay.num" class="item">
                    <img src="../../assets/msg/msg_logo2.png" alt="">
               </el-badge>
               <div class="message_item_content">
                   <div class="message_item_content_title">支付通知</div>
                   <div class="message_item_content_time">{{message.pay.time}}</div>
               </div>
           </div>
           <!-- <div class="message_item">
               <el-badge :value="5" class="item">
                    <img src="../../assets/msg/msg_logo3.png" alt="">
               </el-badge>
               <div class="message_item_content">
                   <div class="message_item_content_title">订单消息</div>
                   <div class="message_item_content_time">04月12日 11:25</div>
               </div>
           </div> -->
       </div>
   </div>
</template>

<script>
import headerTab from '../../components/header_tab'
export default {
   data (){
       return {
           tabList:[
               {name:'消息提醒',id:1}
           ],
           message:{
               pay:{
                   num:0,
                   time:''
               },
               system:{
                   num:0,
                   time:''
               }
           }
       }
   },
   components: {
       headerTab
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       goRouter(path){
           this.$router.push({path:path});
       },
       getMessage(){
           this.$get('MessageNum',{})
            .then(data => {
                console.log(data);
                this.message = data;
            }, error => {
                this.$message.error(error);
            });;
       }
   },
   created() {
       
   },
   mounted() {
       this.getMessage();
   }
}
</script>

<style scoped lang='less'>
.message{
    padding: 0 20px;
    &_item{
        height: 72px;
        display: flex;
        align-items: center;
        padding: 14px 0 10px 0;
        border-bottom:1px solid #EEEEEE;
        cursor: pointer;
        img{
            width:49px;
            height: 49px;
            
        }
        /deep/ .el-badge__content{
            right:16px;
            top:8px;
            background:#FF3B30;
        }
        &_content{
            margin-left:18px;
            &_title{
                font-size: 18px;
                color:#333;
            }
            &_time{
                font-size: 14px;
                color:#999999;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/message/message.vue